import React, { memo } from "react";
import { formats } from "investira.sdk";
import { HighchartsReact } from "investira.react.charts";

const EmissoresChart = memo((props) => {
  const { data = [] } = props;

  const processData = (data) => {
    const xTotal = data.reduce((sum, item) => sum + item.financeiro, 0);
    const xThreshold = xTotal * 0.01; // 1% do total

    const xMainData = [];

    let xOthersSumFinanceiro = 0;
    let xOthersSumAtivos = 0;

    data.forEach((item) => {
      if (item.financeiro >= xThreshold) {
        xMainData.push({
          name: item.pessoa_fantasia, // Usa pessoa_fantasia como name
          y: item.financeiro, // Usa financeiro como y
          dataLabels: {
            // formatter: function () {
            //   // Mostra label apenas se o valor for maior que 5% do total
            //   if (
            //     this.y / this.series.data.reduce((a, b) => a + b.y, 0) >
            //     0.05
            //   ) {
            //     return this.y;
            //   }
            //   return null;
            // },
            color: "#FFFFFF", // Set the color of data labels to red
            enabled: true,
            //crop: false,
            //overflow: "allow",
            //padding: 5,
            // style: {
            //   fontSize: "12px",
            //   textOverflow: "none",
            //   //whiteSpace: "nowrap",
            // },
            //alignTo: "plotEdges",
            //connectorShape: "straight",
            //connectorPadding: 5,
          },
          metadata: {
            ...item,
            financeiro: formats.formatNumber(item.financeiro, 2, true, true),
          },
        });
      } else {
        xOthersSumFinanceiro += item.financeiro;
        xOthersSumAtivos += item.quantidade_ativos;
      }
    });

    if (xOthersSumFinanceiro > 0) {
      xMainData.push({
        name: "Outros",
        y: xOthersSumFinanceiro,
        dataLabels: {
          color: "#FFFFFF", // Set the color of data labels to red
        },
        metadata: {
          financeiro: formats.formatNumber(xOthersSumFinanceiro, 2, true, true),
          quantidade_ativos: xOthersSumAtivos,
        },
      });
    }

    return xMainData;
  };

  const xOptions = {
    chart: {
      type: "pie",
      height: "400px",
    },
    title: false,
    plotOptions: {
      pie: {
        innerSize: "50%",
        borderColor: "#2e2e46", // Cor do contorno (borda)
        borderWidth: 2, // Largura do contorno
        shadow: false,
        center: ["50%", "50%"],
        dataLabels: {
          enabled: true,
          useHTML: true,
          formatter: function () {
            return `<span style="color: #FFFFFF; text-decoration: none;">${this.point.name}</span>`;
          },
          style: {
            color: "#FFFFFF",
            textOutline: "none",
          },
        },
      },
    },
    tooltip: {
      useHTML: true,
      style: {
        zIndex: 1000, // Set a high z-index for the tooltip
      },
      pointFormat: `Financeiro: <b>{point.metadata.financeiro}</b><br>Quantidade de Ativos: <b>{point.metadata.quantidade_ativos}</b>`,
    },
    series: [
      {
        name: "Mercado",
        colorByPoint: true,
        data: processData(data),
        dataLabels: {
          color: "#ffffff",
          enabled: true,
          style: {
            fontSize: "11px", // Reduz o tamanho da fonte
          },
          formatter: function () {
            const xTotal = this.series.data.reduce((a, b) => a + b.y, 0);
            const xCurrentPercentual = this.y / xTotal;
            // Mostra label apenas se o valor for maior que 5% do total

            if (xCurrentPercentual > 0.05) {
              return (
                this.key.substring(0, 140) +
                (this.key.length > 140 ? "..." : "")
              );
            }
            return null;
          },
        },
      },
    ],
  };

  return <HighchartsReact options={xOptions} drilldown />;
});

export default EmissoresChart;
